module.exports = __webpack_public_path__ + "img/calendar-27.1818679f.svg";